import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '../api/http-game-api';

const STORAGE_KEY = 'streaks.pending.submits';
const STALE_THRESHOLD_MS = 10_000;

interface PendingSubmit {
  txUuid: string;
  receivedAt: number;
}

@Injectable({ providedIn: 'root' })
export class SubmitQueueService {
  constructor(@Inject(API_BASE_URL) private baseUrl: string) {}

  enqueue(txUuid: string): void {
    const list = this.read();
    if (list.some((p) => p.txUuid === txUuid)) return;
    list.push({ txUuid, receivedAt: Date.now() });
    this.write(list);
  }

  ack(txUuid: string): void {
    this.write(this.read().filter((p) => p.txUuid !== txUuid));
  }

  drainStaleViaBeacon(): void {
    const stale = this.read().filter(
      (p) => Date.now() - p.receivedAt > STALE_THRESHOLD_MS,
    );
    for (const p of stale) {
      this.sendBeacon(p.txUuid);
    }
  }

  drainAllViaBeacon(): void {
    for (const p of this.read()) {
      this.sendBeacon(p.txUuid);
    }
  }

  list(): PendingSubmit[] {
    return this.read();
  }

  private sendBeacon(txUuid: string): boolean {
    try {
      const blob = new Blob([JSON.stringify({ txUuid })], {
        type: 'application/json',
      });
      return navigator.sendBeacon(`${this.baseUrl}/submit-quiz`, blob);
    } catch {
      return false;
    }
  }

  private read(): PendingSubmit[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private write(list: PendingSubmit[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {
      // localStorage unavailable
    }
  }
}
